import { useEffect, useState } from "react";

function Search() {
  const [query, setQuery] = useState("");
  const [students, setStudents] = useState([]);
  const [results, setResults] = useState([]);

  useEffect(() => {
    fetch("https://student-backend-infs-202.onrender.com/students")
      .then((res) => res.json())
      .then((data) => setStudents(data))
      .catch((err) => console.log(err));
  }, []);

  const handleSearch = () => {
    const filtered = students.filter((s) =>
      s.FullName.toLowerCase().includes(query.toLowerCase())
    );

    setResults(filtered);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Search Student</h2>

      <div style={{ display: "flex", gap: "10px" }}>
        <input
          placeholder="Enter student name..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            padding: "10px",
            width: "100%",
            maxWidth: "300px",
          }}
        />

        <button
          onClick={handleSearch}
          style={{
            padding: "10px",
            background: "black",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Search
        </button>
      </div>

      <div style={{ marginTop: "20px" }}>
        {results.length > 0 ? (
          results.map((s) => (
            <div
              key={s.StudentID}
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "12px",
                marginBottom: "10px",
              }}
            >
              <h3>{s.FullName}</h3>
              <p>Course: {s.Course}</p>
              <p>ID: {s.StudentID}</p>
            </div>
          ))
        ) : (
          query && <p>No student found</p>
        )}
      </div>
    </div>
  );
}

export default Search;